











































































































/* eslint-disable class-methods-use-this */
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { adminForgotPassword } from '@/configs/api-path';
import ApiErrorMixin from '@/mixins/api-error';
import ApiStatusMixin from '@/mixins/api-status';
import { Getter } from 'vuex-class';
import { ProjectMenu } from '@/models/project';

@Component
export default class PageAuthForgotPassword extends mixins(ApiErrorMixin, ApiStatusMixin) {
  loginForm: {
    mobile: string | null;
    name: string | null;
    projectId: number | null;
  } = {
    mobile: null,
    name: null,
    projectId: null,
  };

  @Getter('app/getMenuProjectsLastest') menuProjects!: ProjectMenu[];

  get projectOptions(): Array<{
    label: string;
    code: string | number | null;
  }> {
    return [
      {
        code: null,
        label: '請選擇',
      },
      {
        label: '管理人員',
        code: 0,
      },
      ...this.menuProjects
        .map((project: ProjectMenu) => ({
          code: project.id,
          label: project.name,
        })),
    ];
  }

  get processing() {
    return this.isApiLoading;
  }

  async forgotPasswordSubmit() {
    try {
      console.log({
        mobile: this.loginForm.mobile,
        name: this.loginForm.name,
        projectId: this.loginForm.projectId,
      });
      this.setApiLoading();
      const { data: resetPasswordResponse } = await this.$axios.post<{
        code: number;
      }>(adminForgotPassword, {
        mobile: this.loginForm.mobile,
        name: this.loginForm.name,
        projectId: this.loginForm.projectId,
      });
      this.setApiPending();

      if (resetPasswordResponse.code === 0) {
        this.$notify.show('success filled', `已發送密碼重設簡訊至 ${this.loginForm.mobile}`, '忘記密碼');
      } else {
        this.apiErrorCodeAlert(resetPasswordResponse.code, '忘記密碼');
      }
    } catch (error) {
      this.setApiPending();
      this.apiHttpErrorAlert(error.response, '忘記密碼');
      console.error(error);
    }
  }
}
